import React from 'react';

// Helpers
import * as ReviewsHelpers from 'Shared/model_helpers/Reviews.helper';

// Hooks
import { useUser } from 'Shared/utils/hooks/use-user';

// Utils
import { isFeedbackSharedAnonymously } from 'Shared/utils/Reviews.utils';

// Components
import { WpAlert } from 'Wpds/components/alert';
import { WpText } from 'Wpds/components/text';
import { WpIcon } from 'Wpds/components/icon';

type Props = {
  review;
  text: string;
};

const AnonymousPeerReviewAlert = ({ review, text }: Props) => {
  const receiverSlug = ReviewsHelpers.getReceiverSlug(review);
  const { displayName: receiverDisplayName } = useUser({ slug: receiverSlug });

  const isPeerReviewSharedAnonymously = isFeedbackSharedAnonymously({ review });

  const message = text?.replace('%receiverName%', receiverDisplayName);

  if (!text) return null;

  return (
    <WpAlert type="warning" icon={<WpIcon name={isPeerReviewSharedAnonymously ? 'eye' : 'eye-slash'} />}>
      <WpText tag="span" variant="bodySm">
        {message}
      </WpText>
    </WpAlert>
  );
};

export default AnonymousPeerReviewAlert;
